import messages from './cmsVideoListing.json' with { type: 'json' };

export const cmsVideoListingEn: Readonly<typeof messages> = messages;
